import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CampaignService} from '../../../admin/services/campaign.service';
import {Campaign} from '../../../admin/models/campaign';
import {RegistryService} from '../../services/registry.service';
import {faCheckCircle} from '@fortawesome/pro-light-svg-icons';

@Component({
    selector: 'app-marketing-popup',
    templateUrl: './marketing-popup.component.html',
    styleUrls: ['./marketing-popup.component.css']
})
export class MarketingPopupComponent implements OnInit {


    subscription_success = false;
    campaign: Campaign;
    popup_text = '';

    icon_success = faCheckCircle

    constructor(private dialogRef: MatDialogRef<MarketingPopupComponent>
        , @Inject(MAT_DIALOG_DATA) public data: any,
                public registry: RegistryService,
                private campaignService: CampaignService
    ) {
    }

    isSending = false;

    form = new FormGroup({

        email: new FormControl(''),
    });


    ngOnInit(): void {

        this.campaign = this.data.campaign;
        this.popup_text = this.campaign['popup_text_' + this.registry.currentLang];
    }

    close(event = null) {

        if(event)
        {
            event.preventDefault();
        }

        localStorage.setItem('marketing_pop_up_status', '1');
        this.dialogRef.close();

    }

    subscribe() {
        // TODO

        let component = this;
        this.campaignService.subscribeCampaign(this.data.campaign.id, this.form.value.email,this.registry.websiteId).subscribe(function (result) {

            component.subscription_success = true;

        });


    }


}
